'use strict';

const $ = require('jquery');

$('.video_thumbnail--play img').on('click', function() {
    // If videoelement has an iframe instead of file
    let $parentElement = $(this).closest('.video_thumbnail');
    $parentElement.addClass('played');

    if ($parentElement.find('.video_thumbnail--video iframe')) {
        // If videoelement has an iframe instead of file
        let $videoElement = $parentElement.find('.video_thumbnail--video iframe');
        let $videoSrc = $videoElement.attr('src');

        if ($videoSrc.indexOf('youtube') !== -1) {
            // If videoelement is a youtubevideo put autoplay to src value
            let $videoSrcAutoplay = $videoSrc + '?autoplay=1&mute=1&playsinline=1';
            $videoElement.attr('src', $videoSrcAutoplay);
        }
    }
});
